import React from "react";

export const LayoutContext = React.createContext({
  hasLayout: false,
  setHasLayout: () => {},
});
